import React from "react";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import Axis from "../../organisms/axis/axis";
import Carousel from "../../organisms/carousel/carousel";
import Emotions from "../../organisms/emotions/emotions";
import GalleryExtended from "../../organisms/gallery-extended/galleryExtended";
import GridCardsSection from "../../organisms/grid-cards-section/gridCardsSection";
import PriceInformation from "../../organisms/price-information/priceInformation";
import VideoService from "../../organisms/video-service/videoService";
import Gallery from "../../organisms/gallery/gallery";
import GalleryCards from "../../organisms/gallery-cards/galleryCards";
import GenreSelector from "../../organisms/genre-selector/genreSelector";
import ArticleContentDescription from "../../molecules/article-content-description/articleContentDescription";
import BookCarousel from "../../molecules/book-carousel/bookCarousel";
import CardContact from "../../molecules/card-contact/cardContact";
import CardColumns from "../../molecules/card-colums/cardColumns";
import ContentRotator from "../../molecules/content-rotator/contentRotator";
import DownloadsList from "../../molecules/downloads-list/downloadsList";
import Featured from "../../molecules/featured/featured";
import FeaturedAuthors from "../../molecules/featured-authors/featuredAuthors";
import FrequentlyAskedQuestions from "../../molecules/frequent-questions/frequent-questions";
// import GenreSelector from "../../organisms/genre-selector/genreSelector";
import OfficesList from "../../molecules/offices-list/officesList";
import Prominent from "../../molecules/prominent/prominent";
import ReviewCarousel from "../../molecules/review-carousel/reviewCarousel";
import RichtextDescription from "../../atoms/richtext-description/richtextDescription";
import Readtime from "../../atoms/readtime/readTime";
import SectionContainer from "../../molecules/section-container/sectionContainer";
import ClubCarousel from "../../molecules/club-carousel/clubCarousel";
import ClubDetail from "../../organisms/club-detail/clubDetail";
import LaboratoryRotator from '../../organisms/laboratory-rotator/laboratoryRotator';
import Members from '../../molecules/members/members';
import Testimonies from '../../molecules/testimonies/testimonies';
import HeadingOne from "../../atoms/heading-one/headingOne";
// import CardMemberGrid from '../../atoms/card-member-grid/cardMemberGrid';
import MemberGrid from '../../organisms/members-grid/memberGrid'
import GridSectionLab from '../../organisms/grid-section-lab/gridSectionLab'
import GridSectionClub from '../../organisms/grid-section-club/gridSectionClub'
import VideosRotator from '../../organisms/videos-rotator/videosRotator'
import PodcastsRotator from '../../organisms/podcasts-rotator/podcastsRotator'
import MagazineSlider from '../../organisms/magazine-rotator/magazineSlider'
import LastAddedBooks from "../../molecules/last-added-books/lastAddedBooks";
import AuthorSection from "../../organisms/author-section/authorSection";
import BookDetailManual from '../../organisms/book-detail-manual/bookDetailManual'
import RecommenderPage from "../../organisms/recommeder-page/recommenderPage";
import CommentsSection from "../../organisms/comments-section/commentsSection";
import CurrentConversation from "../../organisms/current-conversation/currentConversation";
import MakeComment from '../../molecules/make-comment/makeComment';
import CommentsActivity from '../../molecules/comments-activity/commentsActivity';
import ConversationsRotator from '../../organisms/conversations-rotator/conversationsRotator';
import TopFive from '../../organisms/top-five/topFive';
import Directorio from '../../molecules/directory/directory'
import ArticleSection from '../../molecules/article-section/articleSection';
import BookShlevesAudio from '../../organisms/bookshelves-audio/bookShelvesAudio';
import Map from '../../organisms/map/map';
import VideoPlayer from '../../organisms/video-player/videoPlayer';

interface LibraryInterface {
  content: ReferenciaContenido;
  categoryName: string;
}

const LibraryComponents = (props: LibraryInterface) => {
  const refContent = props.content;
  const categoryName = props.categoryName;

  switch (props.content.tipoComponente) {
    case "AgregadosCategoria":
      return <GridCardsSection {...refContent} nombreCategoria={categoryName} />;
    case "Beneficios":
      return <CardColumns {...refContent} nombreCategoria={categoryName} />;
    case "BuscadorGenero":
      return <GenreSelector {...refContent} nombreCategoria={categoryName} />;
    case "Contacto":
      return <CardContact {...refContent} nombreCategoria={categoryName} />;
    case "ContenidoEnriquecido":
      return <RichtextDescription {...refContent} nombreCategoria={categoryName} />;
    case "ContenidoEnriquecidoArticulo":
      return <ArticleContentDescription {...refContent} nombreCategoria={categoryName}/>;
    case "Destacados":
      return <Prominent {...refContent} nombreCategoria={categoryName} />;
    case "DestacadosHome":
      return <Featured {...refContent} nombreCategoria={categoryName} />;
    case "RotadorAutores":
      return <FeaturedAuthors {...refContent} nombreCategoria={categoryName} />;
    case "RotadorContenidoEditorial":
      return <ReviewCarousel {...refContent} nombreCategoria={categoryName}/>;
    case "DocumentosInteres":
      return <DownloadsList {...refContent} nombreCategoria={categoryName} />;
    case "Ejes":
      return <Axis {...refContent} nombreCategoria={categoryName} />;
    case "Emociones":
      return <Emotions {...refContent} nombreCategoria={categoryName} />;
    case "GaleriaExtendida":
      return <GalleryExtended {...refContent} nombreCategoria={categoryName} />;
    case "GaleriaPrincipal":
      return <Carousel {...refContent} nombreCategoria={categoryName} />;
    case "InformacionInstitucional":
      return <CardColumns {...refContent} nombreCategoria={categoryName} />;
    case "NuestrasSedes":
      return <OfficesList {...refContent} nombreCategoria={categoryName} />;
    case "PreguntasFrecuentes":
      return <FrequentlyAskedQuestions {...refContent} nombreCategoria={categoryName} />;
    case "RotadorData":
      return <BookCarousel {...refContent} nombreCategoria={categoryName}/>;
    case "RotadorPrincipal":
      return <ContentRotator {...refContent} nombreCategoria={categoryName} />;
    case "TiempoLectura":
      return <Readtime {...refContent} nombreCategoria={categoryName} />;
    case "Tarifas":
      return <PriceInformation {...refContent} nombreCategoria={categoryName} />;
    case "VideoService":
      return <VideoService {...refContent} nombreCategoria={categoryName} />;
    case "Galeria":
      return <Gallery {...refContent} nombreCategoria={categoryName} />;
    case "DestacadoParaTi":
      return <GalleryCards {...refContent} nombreCategoria={categoryName} />;
    case "SectionContainer":
      return <SectionContainer {...refContent} nombreCategoria={categoryName} />;
    case "RotadorClubes":
      return <ClubCarousel {...refContent} nombreCategoria={categoryName} />;
    case "TabsClubes":
      return <ClubDetail {...refContent} nombreCategoria={categoryName}/>;
    case 'RotadorLaboratorios':
      return <LaboratoryRotator {...refContent} nombreCategoria={categoryName}/>;
    case 'Testimonios':
      return <Testimonies {...refContent} nombreCategoria={categoryName}/>;
    case 'MiembrosClub':
      return <Members {...refContent} nombreCategoria={categoryName}/>;
    case 'Tituloh1':
      return <HeadingOne {...refContent} />;
    case 'CardsMiembros':
      return <MemberGrid {...refContent} nombreCategoria={categoryName}/>
    case 'CuadriculaLaboratorios':
      return <GridSectionLab {...refContent} nombreCategoria={categoryName} />
    case 'CuadriculaClubes':
      return <GridSectionClub {...refContent} nombreCategoria={categoryName}/>
    case 'CarruselVideos':
      return <VideosRotator {...refContent} nombreCategoria={categoryName}/>
    case 'RotadorPodcast':
      return <PodcastsRotator {...refContent} nombreCategoria={categoryName}/>;
    case 'TabsUltimoAñadido':
      return <LastAddedBooks {...refContent} nombreCategoria={categoryName}/>
    case 'ModuloAutor':
      return <AuthorSection {...refContent} nombreCategoria={categoryName} />;
    case 'DetalleLibro':
      return <BookDetailManual  library={{...refContent}} />
    case 'InternaRecomendador':
      return <RecommenderPage {...refContent} nombreCategoria={categoryName} />;
    case 'ComentariosConversacion':
      return <CommentsSection {...refContent} nombreCategoria={categoryName} />;
    case 'ConversacionEnVivo':
      return <CurrentConversation {...refContent} nombreCategoria={categoryName} />;
    case 'CajonComentarios':
      return <MakeComment referenciaContenido={{...refContent}} showTitle={true} />;
    case 'CuadriculaComentarios':
      return <CommentsActivity {...refContent} nombreCategoria={categoryName}/>;
    case 'CarruselConversaciones':
      return <ConversationsRotator {...refContent} nombreCategoria={categoryName}/>;
    case 'ConversacionesTop':
      return <TopFive {...refContent} nombreCategoria={categoryName}/>;
    case 'RotadorRevistas':
      return <MagazineSlider {...refContent} nombreCategoria={categoryName}/>;
    case 'Directorio':
      return <Directorio open={false} onClose={() => false}/>;
    case 'ArticuloSeccion':
      return <ArticleSection nombreCategoria={categoryName}/>;
    case 'PlayList':
      return <BookShlevesAudio {...refContent} nombreCategoria={categoryName}/>;
    case "MapaSimple":
      return <Map {...refContent} nombreCategoria={categoryName} />;
    case "ReproductorVideos":
      return <VideoPlayer {...refContent} nombreCategoria={categoryName} />;
  }

  return <></>;
};

export default LibraryComponents;
